import React, { useState } from "react";
import { Form, Input, Select, Upload } from "antd";
import Button from "../../atoms/Button";
import { ReactComponent as DownIcon } from "../../svgs/dropdown_icon.svg";
import UploadIcon from "../../svgs/upload.svg";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FileAddOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import toast from "react-hot-toast";
import { uploadDocument } from "../../../utils/API/uploadDocuments";
import { useDispatch } from "react-redux";
import RadioGroup from "../../atoms/RadioGroup";
import { useSelector } from "react-redux";
import { emailotpRequest } from "../../../utils/API/emailOTPrequest";
import { verifyOtp } from "../../../utils/API/verifyOtp";

const { TextArea } = Input;

const allowedFileTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
];

const ContactDetailsForm = ({
  Country,
  shortDescription,
  documents,
  setDocuments,
  contactDetailsRequired,
  setContactDetailsRequired,
  isDisabledForm,
}) => {
  const dispatch = useDispatch();
  let countries = Country.getAllCountries();
  const options = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  const [isCodeSent, setCodeSent] = useState(false);
  const [inputCode, setInputCode] = useState("");
  const [isVarifyCode, setVarifyCode] = useState(false);
  const inputClass = "border-0 border-b-2 rounded-none";
  const [email, setEmail] = useState("");
  const { userType } = useSelector((state) => state.authReducer);

  const [loading, setLoading] = useState(false);

  const onUpload = async (stateName, { file, onSuccess, onError }) => {
    if (documents[stateName].length == 1) {
      toast.error("Maximum 1 file can be uploaded");
      return;
    }

    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      const fileExtensionsString = allowedFileTypes
        .map((fileType) => {
          const parts = fileType.split("/");
          return parts[1];
        })
        .join(", ");
      toast.error(`You can only upload ${fileExtensionsString} files!`);
      return;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.error("File must be smaller than 2MB!");
      return;
    }

    try {
      setLoading(true);
      const response = await uploadDocument(
        file,
        stateName,
        documents[stateName].length + 1,
        1,
        dispatch
      );
      onSuccess();
      setDocuments((prev) => {
        const array = prev[stateName];
        array.push({ name: file.name, url: response.data, status: "done" });
        return {
          ...prev,
          [stateName]: array,
        };
      });
      setLoading(false);
    } catch (error) {
      onError();
      setLoading(false);
      toast.error(error.message);
      console.error(error);
    }
  };

  const handleSentCode = async () => {
    try {
      const userTypeValue = userType;
      await emailotpRequest({ email, userType: userTypeValue });
      setCodeSent(true);
      setVarifyCode(false);
      toast.success("OTP sent to your email");
    } catch (error) {
      toast.error("Failed to send OTP. Please try again.");
    }
  };

  // const handleVarifyCode = () => {
  //   if (inputCode !== "") {
  //     setVarifyCode(true);
  //   } else {
  //     toast.error("Wrong OTP");
  //   }
  // };

  const handleVarifyCode = async () => {
    try {
      const userTypeValue = userType;
      await verifyOtp({ code: inputCode, email, userType: userTypeValue });
      setVarifyCode(true);
      toast.success("OTP verified successfully");
    } catch (error) {
      toast.error("Wrong OTP, please try again.");
    }
  };

  const handleOtpInput = (e) => {
    setInputCode(e.target.value);
  };

  const CustomLabel = ({ label }) => (
    <span>
      <span style={{ color: "red" }}>*</span> {label}
    </span>
  );

  return (
    <>
      <h3 className="text-2xl font-medium text-[#252525] mb-6 mt-12">
        SPOC Details
      </h3>

      <Form.Item
        name="contact-detail-required"
        label="Is contact details are different from above"
        rules={[
          {
            required: true,
            message: "Please select one option",
          },
        ]}
        labelCol={{ span: 24 }}
      >
        <RadioGroup
          options={options}
          className="font-medium text-2xl max-w-4xl"
          onChange={setContactDetailsRequired}
        />
      </Form.Item>

      {contactDetailsRequired === "Yes" && (
        <div>
          <Form.Item
            label="Contact Person name"
            className="font-normal"
            name="contactDetailsPersonName"
            rules={[
              {
                required: true,
                message: "Please enter contact person name",
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 12 }}
          >
            <Input className={inputClass} />
          </Form.Item>

          <div className="w-fit">
            <Form.Item
              label={
                <CustomLabel label="A copy of the passport or government-issued identification" />
              }
              rules={[
                {
                  required: true,
                  message: "Please upload government-issued identification",
                },
              ]}
            >
              <Upload
                maxCount={1}
                showUploadList={false}
                customRequest={onUpload.bind(null, "goverment_issued_id")}
              >
                <Button
                  varient={"primary"}
                  color={"blue"}
                  className={
                    "px-2 py-1 rounded-[5px] text-xs text-white font-medium flex justify-center gap-x-1 items-center"
                  }
                  disabled={isDisabledForm}
                >
                  <img src={UploadIcon} alt="upload icon" className="w-3" />
                  Upload
                  {loading && <LoadingOutlined className="ml-2" />}
                </Button>
              </Upload>
            </Form.Item>

            {documents["goverment_issued_id"].length > 0 && (
              <div className="mb-4 border p-2 rounded-lg">
                {documents["goverment_issued_id"].map(
                  ({ name: fileName, url }, index) => (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.2 }}
                      className="group hover:bg-gray-100 px-2 py-1 flex justify-between items-center rounded-md"
                      key={`${"goverment_issued_id"}_${index}`}
                    >
                      <span>
                        <FileAddOutlined className="mr-2" />
                        <Link
                          to={url}
                          target="_blank"
                          className="hover:text-blue-800"
                        >
                          {" "}
                          {fileName}
                        </Link>
                      </span>
                      <DeleteOutlined
                        className="hidden group-hover:block cursor-pointer hover:text-blue-800"
                        onClick={() => {
                          const updatedArray = documents["goverment_issued_id"];
                          updatedArray.splice(index, 1);
                          setDocuments((prev) => {
                            return {
                              ...prev,
                              goverment_issued_id: updatedArray,
                            };
                          });
                        }}
                      />
                    </motion.div>
                  )
                )}
              </div>
            )}
          </div>

          <Form.Item label={"Contact details"} labelCol={{ span: 24 }} required>
            <div className="flex mt-2">
              <Form.Item
                className="w-[80px] mr-4"
                initialValue={"91"}
                name={"contactDetailsPhoneCode"}
                rules={[
                  {
                    required: true,
                    message: "Please select phone code",
                  },
                ]}
              >
                <Select
                  defaultValue={"91"}
                  className="secondary_variant"
                  suffixIcon={
                    <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                  }
                  placeholder={"Select Code"}
                >
                  {countries.map((ele, index) => (
                    <Select.Option
                      key={`option_${index}`}
                      value={ele.phonecode}
                    >
                      {ele.flag} +{ele.phonecode}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                className="w-[calc(100%/4)] pr-4"
                name={"contactDetailsContactNumber"}
                rules={[
                  {
                    required: true,
                    message: "Please input contact number",
                  },

                  {
                    pattern: /^[0-9]*$/,
                    message: "Please enter a valid contact number",
                  },
                ]}
              >
                <Input placeholder="Contact no." className={inputClass} />
              </Form.Item>
              <Form.Item
                className="w-[calc(100%/4)]"
                name="contactDetailsEmail"
                rules={[
                  {
                    type: "email",
                    message: "The input is not a valid email",
                  },
                  {
                    required: true,
                    message: "Please enter your email",
                  },
                ]}
              >
                <Input
                  className={inputClass}
                  type="email"
                  placeholder="Email-id"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Item>
              <div>
                <Button
                  varient="rounded"
                  borderColor="blue"
                  className={
                    isCodeSent
                      ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal  "
                      : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800  text-blue-800 font-normal "
                  }
                  onClick={handleSentCode}
                  disabled={isDisabledForm}
                >
                  {isCodeSent ? "Re-send" : "Send Code"}
                </Button>
              </div>
              <div className="w-24 mr-4">
                <Form.Item
                  name="contactDetailsOtp"
                  rules={[
                    { required: true, message: "Please enter the OTP" },
                    {
                      validator: (_, value) => {
                        if (isVarifyCode ===true) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("OTP must be verified")
                        );
                      },
                    },
                  ]}
                >
                  <Input
                    className={inputClass}
                    value={inputCode}
                    onChange={handleOtpInput}
                    type="text"
                    placeholder="OTP"
                    disabled={isVarifyCode}
                  />
                </Form.Item>
                {/* <Input
                  className={inputClass}
                  value={inputCode}
                  onChange={(e) => handleOtpInput(e)}
                  type="text"
                  placeholder="OTP"
                /> */}
              </div>
              <div>
                <Button
                  varient="rounded"
                  className={
                    isVarifyCode
                      ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal  "
                      : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800  text-blue-800 font-normal "
                  }
                  onClick={handleVarifyCode}
                  disabled={isDisabledForm}
                >
                  {isVarifyCode ? "Verified" : "Verify"}
                </Button>
              </div>
            </div>
            {shortDescription && (
              <Form.Item
                label={"Short Description"}
                name={"contactDetailsShortDescription"}
                rules={[
                  {
                    required: true,
                    message: "Please enter short description",
                  },
                ]}
                labelCol={{ span: 24 }}
              >
                <div className="text-area">
                  <TextArea
                    showCount
                    maxLength={600}
                    className="border-2 focus-within:shadow-none rounded-lg"
                    style={{ height: 100, resize: "none" }}
                  />
                </div>
              </Form.Item>
            )}
          </Form.Item>
        </div>
      )}
    </>
  );
};

export default ContactDetailsForm;
